<template>
    <div class="animated fadeIn">
        <!--div class="row">
            <div class="col-sm-12">
                <b-card>
                    <div slot="header">
                        <strong>{{$t('NEWACLOBJECT')}}</strong>
                    </div>
                    <div class="row mb-lg">
                        <div class="col-sm-12">
                            <b-form-fieldset v-bind:label="$t('OBJECTNAME')">
                                <inputvalidation :formerror="formError" name="objectName">
                                    <b-form-input type="text" v-model="formData.objectName" v-bind:placeholder="$t('OBJECTNAME')"></b-form-input>
                                </inputvalidation>
                            </b-form-fieldset>
                        </div>
                    </div>
                    <div class="row mb-lg">
                        <div class="col-sm-12">
                            <b-form-fieldset v-bind:label="$t('OBJECTFUNCTION')">
                                <b-form-input type="text" v-model="formData.objectFunction" v-bind:placeholder="$t('OBJECTFUNCTION')"></b-form-input>
                            </b-form-fieldset>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <b-form-fieldset v-bind:label="$t('OBJECTDESCRIPTION')">
                                <b-form-textarea type="text" v-model="formData.objectDescription" v-bind:placeholder="$t('OBJECTDESCRIPTION')"></b-form-textarea>
                            </b-form-fieldset>
                        </div>
                    </div>
                    <div slot="footer">
                        <p class="bg-danger" v-if="formError.error && typeof formError.notice == 'string'">{{formError.notice}}</p>
                        <b-button type="submit" size="md" variant="primary" v-on:click.prevent="saveAcl" class="pull-right">{{$t('SUBMIT')}}</b-button>
                    </div>
                </b-card>
            </div>
        </div-->
        <div class="row">
            <div class="col-sm-12 vh-header d-flex flex-column pr-0">
                <div class="card flex-1-auto h-100 overflow-auto">
                    <div class="card-header card-header-with-button">
                        <h5>{{$t('ACLOBJECTS')}}</h5>
                        <button type="button" class="btn-bis btn-primary" @click="showModal()">{{$t('NEW')}}</button>
                    </div>
                    <div class="flex-0-auto">
                        <div class="buttons-group buttons-group-bis">
                            <b-form-fieldset v-bind:label="$t('GROUP')" class="mr-2">
                                <b-form-select :options="aclGroups.root" v-model="searchGroupId" value-field="groupId" text-field="groupName"></b-form-select>
                            </b-form-fieldset>
                            <b-form-fieldset v-bind:label="$t('SEARCH')">
                                <b-form-input v-model="pagination.query"></b-form-input>
                            </b-form-fieldset>
                        </div>
                    </div>
                    <div class="card-body" v-if="acl.root == null || !acl.root.length">
                        <p class="center">{{$t('NODATAFOUND')}}</p>
                    </div>
                    <div class="table-responsive h-100 flex-1-auto" v-if="acl.root != null && acl.root.length">
                        <table class="table table-bis">
                            <thead>
                                <tr>
                                    <th>{{$t('ID')}}</th>
                                    <th>{{$t('OBJECTNAME')}}</th>
                                    <th>{{$t('OBJECTFUNCTION')}}</th>
                                    <th>{{$t('INSERTPRIVILAGE')}}</th>
                                    <th>{{$t('UPDATEPRIVILAGE')}}</th>
                                    <th>{{$t('DELETEPRIVILAGE')}}</th>
                                    <th>{{$t('INSTANTIATE')}}</th>
                                    <th>{{$t('OWNERHANDLING')}}</th>
                                    <th>{{$t('COMPANYHANDLING')}}</th>
                                    <th>{{$t('SUBCOMPANYHANDLING')}}</th>
                                    <th>{{$t('DELETE')}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="priv in acl.root" :key="`${priv.objectId}_${priv.objectName}`">
                                    <td>{{priv.objectId}}</td>
                                    <td>{{priv.objectName}}</td>
                                    <td>{{priv.objectFunction}}</td>
                                    <td>
                                        <c-switch type="text" variant="primary-outline-alt" v-bind:on="$t('ON')" v-bind:off="$t('OFF')" :pill="true" :checked="(priv.insertPrivilage == 1) ? true : false" v-on:change="setAcl(priv, 'insertPrivilage')" />
                                    </td>
                                    <td>
                                        <c-switch type="text" variant="primary-outline-alt" v-bind:on="$t('ON')" v-bind:off="$t('OFF')" :pill="true" :checked="(priv.updatePrivilage == 1) ? true : false" v-on:change="setAcl(priv, 'updatePrivilage')" />
                                    </td>
                                    <td>
                                        <c-switch type="text" variant="primary-outline-alt" v-bind:on="$t('ON')" v-bind:off="$t('OFF')" :pill="true" :checked="(priv.deletePrivilage == 1) ? true : false" v-on:change="setAcl(priv, 'deletePrivilage')" />
                                    </td>
                                    <td>
                                        <c-switch type="text" variant="primary-outline-alt" v-bind:on="$t('ON')" v-bind:off="$t('OFF')" :pill="true" :checked="(priv.instantiate == 1) ? true : false" v-on:change="setAcl(priv, 'instantiate')" />
                                    </td>
                                    <td>
                                        <c-switch type="text" variant="primary-outline-alt" v-bind:on="$t('ON')" v-bind:off="$t('OFF')" :pill="true" :checked="(priv.ownerAction == 1) ? true : false" v-on:change="setAcl(priv, 'ownerAction')" />
                                    </td>
                                    <td>
                                        <c-switch type="text" variant="primary-outline-alt" v-bind:on="$t('ON')" v-bind:off="$t('OFF')" :pill="true" :checked="(priv.companyAction == 1) ? true : false" v-on:change="setAcl(priv, 'companyAction')" />
                                    </td>
                                    <td>
                                        <c-switch type="text" variant="primary-outline-alt" v-bind:on="$t('ON')" v-bind:off="$t('OFF')" :pill="true" :checked="(priv.subCompanyAction == 1) ? true : false" v-on:change="setAcl(priv, 'subCompanyAction')" />
                                    </td>
                                    <td class="table-buttons">
                                        <b-button type="reset" class="btn-table table-btn-delete" v-on:click.prevent="deleteAcl(priv.objectId)">{{$t('DELETE')}}</b-button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="table-navigation">
                        <nav>
                            <b-pagination align="center" :total-rows="parseInt(acl.totalCount)" v-model="pagination.currentPage" :per-page="pagination.limit"></b-pagination>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
        <b-modal ref="formmodal" centered hide-header ok-title="submit" hide-footer no-close-on-backdrop no-close-on-esc>
            <div class="modal-header">
                <div class="modal-title">
                    <h5>{{$t('NEWACLOBJECT')}}</h5>
                </div>
                <button type="button" aria-label="Close" @click="hideModal()" class="close"><img src="../../../../assets/img/icon-close.svg"></button>
            </div>
            <div class="d-block mt-2 modal-content-inside">
                <div class="row">
                    <div class="col-sm-12">
                        <b-form-fieldset v-bind:label="$t('OBJECTNAME')">
                            <inputvalidation :formerror="formError" name="objectName">
                                <b-form-input type="text" v-model="formData.objectName" v-bind:placeholder="$t('OBJECTNAME')"></b-form-input>
                            </inputvalidation>
                        </b-form-fieldset>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <b-form-fieldset v-bind:label="$t('OBJECTFUNCTION')">
                            <b-form-input type="text" v-model="formData.objectFunction" v-bind:placeholder="$t('OBJECTFUNCTION')"></b-form-input>
                        </b-form-fieldset>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <b-form-fieldset v-bind:label="$t('OBJECTDESCRIPTION')">
                            <b-form-textarea type="text" v-model="formData.objectDescription" v-bind:placeholder="$t('OBJECTDESCRIPTION')"></b-form-textarea>
                        </b-form-fieldset>
                    </div>
                </div>
                <div class="text-center mt-lg">
                    <b-btn class="mr-2 btn-bis btn-cancel" @click="hideModal()">{{$t('CANCEL')}}</b-btn>
                    <b-btn class="btn-bis btn-primary" @click="saveAcl(formData)">{{$t('SAVE')}}</b-btn>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>

import cSwitch from '../../../components/lib/Switch'
import { mapActions, mapGetters } from 'vuex'
import AclApi from '@/api/admin/acl/Acl'
import AclGroupsApi from '@/api/admin/acl_groups/AclGroups'

export default {
  name: 'Acl',
  components: {
    cSwitch
  },
  data: function()
  {
    return {
      acl: {},
      aclGroups: {},
      formGroupData: {
        groupName: '',
        copyGroupId: ''
      },
      formData: {
        id: '',
        objectName: '',
        objectFunction: '',
        objectDescription: ''
      },
      formError: {},
      pagination:
      {
        query: '',
        currentPage: 1,
        limit: 20,
        searchTimeout: false
      },
      paginationGroups:
      {
        query: '',
        currentPage: 1,
        limit: 25,
        searchTimeout: false
      },
      searchGroupId: 2,
      newAclVisible: false,
      formGroupError: {}
    }
  },
  created: function()
  {
    var me = this;
    me.getAcl();
    me.getAclGroups();
  },
  methods:
  {
    async saveAcl()
    {
        const me = this;
        try
        {
            const data = await AclApi.saveAcl(me.formData);
            if (data.error)
            {
                me.formError = data;
                throw (data);
            }

            me.formError = {};
            me.formData = {
              id: '',
              objectName: '',
              objectFunction: '',
              objectDescription: ''
            };
            me.hideModal();
            me.getAcl();
        }
        catch (error)
        {
            me.$notify.notice(error);
        }
    },
    async setAcl(priv, type)
    {
        const me = this;
        try
        {
            priv[type] = (priv[type] == 0) ? 1 : 0;
            priv.groupId = me.searchGroupId;
            const data = await AclApi.updatePrivilageByGroupId(priv);
            if (data.error)
            {
                throw (data);
            }
            me.getAcl();
        }
        catch (error)
        {
            me.$notify.notice(error);
        }
    },
    async getAcl()
    {
        const me = this;
        try
        {
            const data = await AclApi.getPrivilagesByGroupId(me.getParams);
            if (data.error && data.error === true)
            {
                throw (data);
            }
            me.acl = data;
        }
        catch (error)
        {
            me.$notify.notice(error);
        }
    },
    async getAclGroups()
    {
        const me = this;
        try
        {
            const data = await AclGroupsApi.selectRow(me.getGroupParams);
            if (data.error && data.error === true)
            {
                throw (data);
            }
            me.aclGroups = data;
        }
        catch (error)
        {
            me.$notify.notice(error);
        }
    },
    async deleteAcl(id)
    {
        const me = this;
        me.$store.commit('setModalAlert',
            {
                text: me.$i18n.t('AREYOUSHURE'),
                async btnAction()
                {
                    const data = await AclApi.deleteAcl({id: id});
                    me.$notify.notice(data);
                    me.getAcl();
                },
            });
    },
    showModal(item)
      {
          const me = this;
          if (typeof item !== 'undefined')
          {
              me.formData = { ...item };
          }
          this.$refs.formmodal.show();
      },
    hideModal()
      {
          const me = this;

          me.formError = {};
          me.formData = {...me.formDataField},
          this.$refs.formmodal.hide();
      },
  },
  watch:
  {
    'pagination.currentPage': function(val)
    {
      var me = this;
      me.getAcl();
    },
    'pagination.query': function(val)
    {
      var me = this;

      if(me.pagination.searchTimeout != false) clearTimeout(me.pagination.searchTimeout);

      me.pagination.searchTimeout = setTimeout(function()
      {
        me.getAcl();
        me.pagination.searchTimeout = false;
      }, 300);
    },
    'paginationGroups.currentPage': function(val)
    {
      var me = this;
      me.getAclGroups();
    },
    'paginationGroups.query': function(val)
    {
      var me = this;

      if(me.paginationGroups.searchTimeout != false) clearTimeout(me.paginationGroups.searchTimeout);

      me.paginationGroups.searchTimeout = setTimeout(function()
      {
        me.getAclGroups();
        me.paginationGroups.searchTimeout = false;
      }, 300);
    },
    searchGroupId()
    {
      var me = this;
      me.getAcl();
    }
  },
  computed:
  {
    getParams: function()
    {
      var me = this;
      var data = Object.assign({}, me.pagination, {});
      data.start = (data.currentPage-1)*data.limit;
      data.groupId = me.searchGroupId;
      return data;
    },
    getGroupParams: function()
    {
      var me = this;
      var data = Object.assign({}, me.paginationGroups, {});
      data.start = (data.currentPage-1)*data.limit;
      return data;
    }
  }
}
</script>
